import { render, staticRenderFns } from "./Testings.vue?vue&type=template&id=3ac5c4b2&scoped=true"
import script from "./Testings.vue?vue&type=script&lang=ts"
export * from "./Testings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac5c4b2",
  null
  
)

export default component.exports